(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-brand-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.cg-brand-showcase';
    const placeDescriptions = (root) => {
      if (!root) return;
      root.querySelectorAll('[data-cg-product-description]').forEach((description) => {
        const slide = description.closest('.cg-brand-showcase__product-slide');
        if (!slide) return;
        const information = slide.querySelector('.card__information');
        if (!information || description.parentElement === information) return;
        const heading = information.querySelector('.card__heading');
        if (heading) {
          heading.insertAdjacentElement('afterend', description);
        } else {
          information.prepend(description);
        }
      });
    };
    document.querySelectorAll(selector).forEach(placeDescriptions);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches && event.target.matches(selector)) {
        placeDescriptions(event.target);
        return;
      }
      placeDescriptions(event.target.querySelector ? event.target.querySelector(selector) : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qool-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initQoolComparison = (root) => {
    if (!root || root.dataset.qoolInitialized === 'true') return;

    root.dataset.qoolInitialized = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-qool-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-qool-panel]'));

    const activate = (target) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.qoolTab === target;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.qoolPanel !== target;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.qoolTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        const nextTab = tabs[nextIndex];
        activate(nextTab.dataset.qoolTab);
        nextTab.focus();
      });
    });

    activate(root.dataset.defaultCompetitor || 'passive');
  };

  const initAll = (scope) => {
    if (!scope) return;
    if (scope.matches && scope.matches('.qool-comparison')) initQoolComparison(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('.qool-comparison').forEach(initQoolComparison);
    }
  };

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qool-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registry = window.QoolFeaturesRegistry = window.QoolFeaturesRegistry || {};

    const initRoot = (root) => {
      if (!root || root.dataset.qoolInitialized === 'true') return;

      root.dataset.qoolInitialized = 'true';

      const items = Array.from(root.querySelectorAll('[data-qool-feature-block]'));
      const images = Array.from(root.querySelectorAll('[data-qool-image]'));
      const current = root.querySelector('[data-qool-current]');
      let syncing = false;

      const updateVisual = (index) => {
        images.forEach((image) => {
          const active = image.dataset.qoolImage === String(index);
          image.classList.toggle('is-active', active);
          image.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        if (current) {
          current.textContent = String(index).padStart(2, '0');
        }
      };

      const activate = (item) => {
        if (!item) return;

        syncing = true;

        items.forEach((other) => {
          const active = other === item;
          other.open = active;
          other.classList.toggle('is-active', active);
        });

        updateVisual(item.dataset.qoolIndex);

        window.requestAnimationFrame(() => {
          syncing = false;
        });
      };

      items.forEach((item) => {
        const summary = item.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          activate(item);
        });

        item.addEventListener('toggle', () => {
          if (syncing) return;

          if (item.open) {
            activate(item);
            return;
          }

          const openItem = items.find((other) => other.open);
          if (openItem) {
            activate(openItem);
          } else {
            activate(item);
          }
        });
      });

      const initiallyOpen = items.find((item) => item.open) || items[0];
      if (initiallyOpen) activate(initiallyOpen);

      root.qoolFeaturesActivate = activate;
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches('[data-qool-features]')) {
        initRoot(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('[data-qool-features]').forEach(initRoot);
      }
    };

    initAll();

    if (!registry.editorListenersAdded) {
      document.addEventListener('shopify:section:load', (event) => {
        initAll(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-qool-feature-block]');
        if (!item) return;

        const root = item.closest('[data-qool-features]');
        if (!root) return;

        initRoot(root);
        if (typeof root.qoolFeaturesActivate === 'function') {
          root.qoolFeaturesActivate(item);
        }
      });

      registry.editorListenersAdded = true;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
